export const PAGE_SIZE = 20;
export const NON_NULL_ERROR = 'Cannot return null for non-nullable field';
export const NOTIFICATION_TYPE_ACCESS_REQUEST_SUBMITTED =
  'NotificationGroupAccessRequestSubmitted';
export const NOTIFICATION_TYPE_ACCESS_REQUEST_APPROVED =
  'NotificationGroupAccessRequestApproved';
export const NOTIFICATION_TYPE_ACCESS_REQUEST_DENIED =
  'NotificationGroupAccessRequestDenied';
